import script from "./PlaceOrderView.vue?vue&type=script&setup=true&lang=js"
export * from "./PlaceOrderView.vue?vue&type=script&setup=true&lang=js"

import "./PlaceOrderView.vue?vue&type=style&index=0&id=097bd2d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-097bd2d6"]])

export default __exports__